export const department = {
  SALESBATT: 'SALESBATT',
  OPEADMIN: 'OPEADMIN',
  SALESTYRE: 'SALESTYRE',
  OPERETAIL: 'OPERETAIL',
  BOARD: 'BOARD',
  ADMIN: 'ADMIN',
  FINANCE: 'FINANCE',
  SALESALUBE: 'SALESALUBE',
  SALESILUBE: 'SALESILUBE',
  ITMARKETG: 'ITMARKETG',
  CSDISTRI: 'CSDISTRI',
  LOGISTICWH: 'LOGISTICWH',
  SALESCVLUB: 'SALESCVLUB',
  CSRETAIL: 'CSRETAIL',
  CORPAFFAIR: 'CORPAFFAIR',
}
